import { Link } from 'react-router-dom';
import { cn } from '../../utils/cn';
import { mainNavigation, supportNavigation } from '../Sidebar/navigation';
import { useUser } from '../../contexts/UserContext';
import { Card } from '../ui/Card';
import { DemoSignup } from './DemoSignup';

export function Footer() {
  const { currentResidence } = useUser();
  const role = currentResidence?.role;

  const getResidenceTypeText = (type: 'condo' | 'cooperative' | null | undefined) => {
    if (type === 'condo') return 'Sameiet';
    if (type === 'cooperative') return 'Borettslaget';
    return 'Bofellesskapet';
  };

  const filteredSupportNavigation = supportNavigation.filter(item => {
    if (!item.roles || (role && role === 'board')) {
      return true;
    }
    return role ? item.roles.includes(role) : false;
  });

  const allNavigation = [...mainNavigation, ...filteredSupportNavigation].map(item => {
    // Spesialhåndtering for "Bofellesskapet" med dynamisk navn
    if (item.to === '/bofellesskapet') {
      return {
        ...item,
        label: getResidenceTypeText(currentResidence?.residence?.type)
      };
    }
    return item;
  });

  // Del navigasjonen i to kolonner
  const midPoint = Math.ceil(allNavigation.length / 2);
  const leftColumn = allNavigation.slice(0, midPoint);
  const rightColumn = allNavigation.slice(midPoint);


  return (
    <footer className="bg-condo-dark text-condo-light">
      <div className="max-w-screen-sm mx-auto px-4 sm:max-w-7xl sm:px-6 lg:px-8 py-10">
        <img 
          src="/images/Condo-logo-light.png" 
          alt="Condo logo" 
          className="h-8 w-auto"
        />
        {/* Desktop Layout */}
        <div className="hidden lg:grid grid-cols-2 gap-12">
          {/* Left Column */}
          <Card className="p-6 -ml-6 bg-condo-dark border-none shadow-none mt-6">
            <div className="grid grid-cols-2 gap-8 h-full justify-evenly">
              <div>
                <ul className="space-y-3">
                  {leftColumn.map((item) => (
                    <li key={item.to}>
                      <Link 
                        to={item.to}
                        className="text-sm font-medium hover:text-condo-light/80 transition-colors"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <ul className="space-y-3">
                  {rightColumn.map((item) => (
                    <li key={item.to}>
                      <Link 
                        to={item.to}
                        className="text-sm font-medium hover:text-condo-light/80 transition-colors"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Card>

          {/* Right Column - Demo Version */}
          <DemoSignup />
        </div>

        {/* Tablet Layout */}
        <div className="hidden md:block lg:hidden">
          <div className="flex flex-col gap-8">
            {/* Demo Section */}
            <DemoSignup />
            
            {/* Navigation Section */}
            <Card className="p-6 bg-condo-dark border-none">
              <div className="grid grid-cols-2 gap-8">
                <div>
                  <ul className="space-y-2">
                    {leftColumn.map((item) => (
                      <li key={item.to}>
                        <Link 
                          to={item.to}
                          className="text-sm hover:text-condo-light/80 transition-colors"
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <ul className="space-y-2">
                    {rightColumn.map((item) => (
                      <li key={item.to}>
                        <Link 
                          to={item.to}
                          className="text-sm hover:text-condo-light/80 transition-colors"
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden">
          <div className="flex flex-col gap-8">
            <DemoSignup />
            <Card className="p-6 bg-condo-dark border-none">
              <div>
                <ul className="space-y-3">
                  {allNavigation.map((item) => (
                    <li key={item.to}>
                      <Link 
                        to={item.to}
                        className="flex items-center gap-2 text-md hover:text-condo-light/80 transition-colors"
                      >
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Card>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-screen-sm mx-auto px-4 sm:max-w-7xl sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-condo-light/80">
            <div className="text-center sm:text-left">
              © 2025 Condo. Alle rettigheter forbeholdt.
            </div>
            <nav 
              className="flex flex-wrap items-center justify-center gap-3 sm:gap-6"
              aria-label="Bunntekst navigasjon"
            >
              <Link 
                to="/personvern" 
                className={cn(
                  "hover:text-white transition-colors",
                  "focus:outline-none focus:ring-2 focus:ring-condo-light focus:ring-offset-2 focus:ring-offset-condo-dark rounded"
                )}
              >
                Personvern
              </Link>
              <Link 
                to="/vilkar" 
                className={cn(
                  "hover:text-white transition-colors",
                  "focus:outline-none focus:ring-2 focus:ring-condo-light focus:ring-offset-2 focus:ring-offset-condo-dark rounded"
                )}
              >
                Vilkår
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}